module.exports = __webpack_public_path__ + "media/images/icons/pinterest-4fb78a5d2dac56acc0f7ccf1ea8a4c0c.svg";